import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=52e56508&"
import script from "./ContentFooter.vue?vue&type=script&lang=js&"
export * from "./ContentFooter.vue?vue&type=script&lang=js&"
import style0 from "./ContentFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e56508')) {
      api.createRecord('52e56508', component.options)
    } else {
      api.reload('52e56508', component.options)
    }
    module.hot.accept("./ContentFooter.vue?vue&type=template&id=52e56508&", function () {
      api.rerender('52e56508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/ContentFooter.vue"
export default component.exports